import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnDestroy } from '@angular/core';

// Serivicios
import { TypeDocumentaryDataService } from './shared/type-documentary-data.service';
import { TypeDocumentaryFormService } from './shared/type-documentary-form.service';
import { TypeDocumentaryConfigService } from './shared/type-documentary-config.service';

// Modelos
import {
  TipoDocumentalPredeterminado,
  SubSeriePredeterminada,
  Const
} from '@app/shared';

import { LocalDataSource } from 'ng2-smart-table';
import { BaseControl, ConfirmComponent } from '@app/shared';
import { ToastrService } from 'ngx-toastr';
import { filter, find, findIndex } from 'lodash';
import { Action } from '../documents.component';
import { AuthenticationService } from '@app/core';
import { Subject } from 'rxjs';
import { environment } from '@env/environment';
import { TemplateRef } from '@angular/core';


@Component({
  selector: 'iw-type-documentary',
  templateUrl: './type-documentary.component.html',
  styleUrls: ['./type-documentary.component.scss'],
  providers: [
    TypeDocumentaryDataService,
    TypeDocumentaryFormService
  ]
})
export class TypeDocumentaryComponent implements OnInit, OnDestroy {

  @Input() set subseries(s: SubSeriePredeterminada[]) {
    this._subseries = s;
    this.loadingSubSeriesDocuments();
  }

  @Input() set typeDocumentary(t: TipoDocumentalPredeterminado[]) {
    this._typeDocumentary = t;
    this.loadingTypeDocumentaryDocuments();
  }

  // Subseries para el select
  subseriesList: SubSeriePredeterminada[] = [];
  // Array de tipo documentales con filtro según la subseries seleccionada
  typesDocumentary: LocalDataSource;
  // Define la accion a realizar en el formulario
  actionForm = '';
  // Pregunta de la modal de confirmaciones
  question = '';
  // Define cuando mostrar la tabla principal o el formulario
  formOpen = false;
  // Define si el tipo documental en accion es para editar o agregar
  typeDocumentaryEdit = true;
  // Define los tipos de permisos que tiene el usuario en sesión
  activateAction = {
    created: false,
    update: false,
    delete: false
  };
  // Configuracion de la tabla
  settings = {};
  // Datos para llenar la tabla
  sourceData: TipoDocumentalPredeterminado[] = [];
  // Contiene el tipo documental seleccionado
  typeDocumentarySelect: TipoDocumentalPredeterminado;
  // Contiene los controles de el formulario de asociaciones
  controls: BaseControl<any>[] = [];
  // Contiene el formulario de envio para guardar o modificar el tipo documental
  formData: FormData = new FormData();

  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // valida el boton de agregar en la tabla
  showAdd: boolean = true;
  // Referencia al componente de confirmación
  @ViewChild('confirm') private confirm: ConfirmComponent;
  // Referencia a la plantilla para el control personalizado de cargar documento
  @ViewChild('fileUpload') fileUpload: TemplateRef<any>;
  // Evento de salida que otifica al padre para refrescar los tipos documentales
  @Output() refreshTypeDocumentary: EventEmitter<Action> = new EventEmitter();
  // Tipos documentales
  private _typeDocumentary: TipoDocumentalPredeterminado[] = [];
  // Subseries
  private _subseries: SubSeriePredeterminada[];
  // id de la subserie seleccionada
  private _idSubserieSelect: any;

  constructor(
    private tdds: TypeDocumentaryDataService,
    private tdfs: TypeDocumentaryFormService,
    private toastr: ToastrService,
    private as: AuthenticationService
  ) { }

  ngOnInit() {
    // Determina los permisos del usuario en sesion
    this.activateAction.created = this.as.confirmPermission(
      Const.types_permissions.administrationDocument,
      Const.types_action_permissions.created
    );
    this.activateAction.update = this.as.confirmPermission(
      Const.types_permissions.administrationDocument,
      Const.types_action_permissions.update
    );
    this.activateAction.delete = this.as.confirmPermission(
      Const.types_permissions.administrationDocument,
      Const.types_action_permissions.delete
    );
    const configTable = new TypeDocumentaryConfigService();
    this.settings = configTable.settings;
    configTable.accion.subscribe((res: any) => {
      switch (res.action) {
        case 'generation':
          this.downloadDocumentGeneration(res.data.id, res.data.rutas[0].ruta_generacion);
          break;
        default:
          this.defineActionCondictions(res.action, res.data);
          break;
      }
    });
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  get typeDocumentary(): TipoDocumentalPredeterminado[] {
    return this._typeDocumentary;
  }

  get subseries(): SubSeriePredeterminada[] {
    return this._subseries;
  }

  /**
   * Obteniendo datos y filtrando según la subserie seleccionada
   *
   * @param {SubSeriePredeterminada} [data]
   * @memberof TypeDocumentaryComponent
   */

  set idSubserieSelect(value: any) {
    if (value !== this.idSubserieSelect) {
      this._idSubserieSelect = value;
      this.updateTypesDocumentary();
    }
  }

  get idSubserieSelect(): any {
    return this._idSubserieSelect;
  }

  /**
   * Cargando las subseries para el selector
   *
   * @memberof TypeDocumentaryComponent
   */
  loadingSubSeriesDocuments() {
    let new_subserie:any = []
    if (this.subseries){
      this.subseries.forEach(element => {
        let name = element.codigo+" - "+element.nombre
        new_subserie.push({id:element.id,nombre:name,codigo:element.codigo,expediente:element.expediente})
      });
    }
    this.subseriesList = new_subserie;
    if (this.idSubserieSelect) {
      const valid = findIndex(this.subseries, { 'id': this.idSubserieSelect });
      if (valid === -1) {
        this.idSubserieSelect = null;
      }
    }
  }

  /**
   * Cargando todos los tipos documentales
   *
   * @memberof TypeDocumentaryComponent
   */
  loadingTypeDocumentaryDocuments() {
    this.sourceData = this.typeDocumentary;
    this.updateTypesDocumentary();
  }

  /**
   * Define las acciones ha realizar
   *
   * @param {('add' | 'update' | 'delete')} [action='add']
   * @param {*} [data]
   * @memberof TypeDocumentaryComponent
   */
  defineActionCondictions(action: 'add' | 'update' | 'delete' = 'add', data?: any) {
    switch (action) {
      case 'add':
        if (this.activateAction.created) {
          this.formOpen = true;
          this.typeDocumentaryEdit = false;
          this.actionForm = 'Agregar';
          this.controls = this.tdfs.getFormTypeDocumentary(this.fileUpload);
        } else {
          this.toastr.error('Usted no posee permisos para agregar los tipos documentales del sistema',
           'Permiso denegado');
        }
        break;
      case 'update':
        if (this.activateAction.update) {
          this.formOpen = true;
          this.typeDocumentaryEdit = true;
          this.actionForm = 'Modificar';
          this.typeDocumentarySelect = data;
          this.controls = this.tdfs.getFormTypeDocumentary(this.fileUpload,this.typeDocumentarySelect);
        } else {
          this.toastr.error('Usted no posee permisos para modificar los tipos documentales del sistema',
           'Permiso denegado');
        }
        break;
      case 'delete':
        if (this.activateAction.delete) {
          this.typeDocumentarySelect = data;
          this.question = '¿Realmente desea eliminar el tipo de documental?';
          this.confirm.open();
        } else {
          this.toastr.error('Usted no posee permisos para eliminar los tipos documentales del sistema',
           'Permiso denegado');
        }
        break;
    }
  }

  /**
   * Activa modal de confirmación
   *
   * @param {boolean} res
   * @memberof TypeDocumentaryComponent
   */
  actionComfirm(res: boolean) {
    if (res) {
      this.deleteTypeDocumentary();
    }
    this.question = '';
  }

  /**
   * Cierra la vista del formulario de creacion o edicion de un tipo documental
   *
   * @memberof TypeDocumentaryComponent
   */
  closeFormTypeDocumentary() {
    this.actionForm = '';
    this.question = '';
    this.formOpen = false;
    this.typeDocumentaryEdit = false;
    this.typeDocumentarySelect = null;
    this.formData = new FormData();

  }

  /**
   * Guarda o edita un tipo de documental en el sistema
   *
   * @param {*} data
   * @memberof TypeDocumentaryComponent
   */
  sended(data: any) {
    if (data) {
      // let typeDocumentary: TipoDocumentalPredeterminado = new TipoDocumentalPredeterminado();
      if (environment.visualizarCodigoTipoDocumental){
        this.formData.append('nombre', data.nombre);
        this.formData.append('codigo',  data.codigo);
        this.formData.append('subserie', this.idSubserieSelect);
        if (data.expediente != null && data.expediente != undefined){
          this.formData.append('expediente',  data.expediente);
       }
      }else{
        this.formData.append('nombre', data.nombre);
        this.formData.append('subserie', this.idSubserieSelect);
        if (data.expediente != null && data.expediente != undefined){
          this.formData.append('expediente',  data.expediente);
        }
      }
      if (this.typeDocumentarySelect) {
        this.tdds.updateTypeDocumentary(this.typeDocumentarySelect.id, this.formData).then(() => {
          this.closeFormTypeDocumentary();
          this.refreshTypeDocumentary.emit('update');
        });
      } else {
        this.tdds.addTypeDocumentary(this.formData).then(() => {
          this.closeFormTypeDocumentary();
          this.refreshTypeDocumentary.emit('add');
        });
      }
  }
}

  /**
   * Elimina un tipo de documental del sistema
   *
   * @private
   * @memberof TypeDocumentaryComponent
   */
  private deleteTypeDocumentary() {
    this.tdds.deleteTypeDocumentary(this.typeDocumentarySelect.id).then(() => {
      this.closeFormTypeDocumentary();
      this.refreshTypeDocumentary.emit('delete');
    }).catch(() => {
      this.closeFormTypeDocumentary();
    });
  }

  /**
   * Actualizar array que filtra según la subserie seleccionada
   *
   * @private
   * @memberof TypeDocumentaryComponent
   */
  private updateTypesDocumentary() {
    if (this.idSubserieSelect) {
      if(environment.hiddenAddNewExpDocument){
        let check_add = find(this.subseriesList,{id:this.idSubserieSelect});
        if (check_add && check_add.expediente){
          this.showAdd = false;
        }else{
          this.showAdd = true;
        }
      }
      this.typesDocumentary = new LocalDataSource(
        filter(this.sourceData, row => row.subserie.id === this.idSubserieSelect)
      );
      this.typesDocumentary.refresh();
    } else if (this.typesDocumentary) {
      this.typesDocumentary.empty();
    }
  }

    /**
   * Agregar o remover un documento
   *
   * @param {*} data
   * @returns {*}
   * @memberof TypeDocumentaryComponent
   */
    onAction(data: any): any {
      if (data.action === 1) {
        this.onAdded(data);
      } else if (data.action === 0) {
        this.onRemoved();
      }
    }
  
  
    /**
     * Controla el evento de cargar un documento de vista previa o generacion
     *
     * @private
     * @param {*} data
     * @returns {*}
     * @memberof TypeDocumentaryComponent
     */
    private onAdded(data: any): any {
        this.formData.append('plantilla_generacion', data.file);
    }
  
    /**
     * Controla el evento de remover un documento cargado de vista previa o generacion
     *
     * @private
     * @returns {*}
     * @memberof TypeDocumentaryComponent
     */
    private onRemoved(): any {
        this.formData.delete('plantilla_generacion');
    }


      /**
   * Valida el documento y emite la acción de descargar el documento de genearicion
   *
   * @private
   * @param {number} data
   * @returns {*}
   * @memberof TypeDocumentaryComponent
   */
  private downloadDocumentGeneration(data: number, name: string): any {
    this.tdds.dowloadFileDocumentGeneration(data).subscribe((res: any) => {
      const a = document.createElement('a');
      a.target = '_blank';
      a.href = res.path;
      a.download = name;
      a.click();
      a.remove();
    });
  }
  
}



// WEBPACK FOOTER //
// ./src/app/administration/documents/type-documentary/type-documentary.component.ts